export default __webpack_public_path__ + "static/media/DJI_0940.MP4.00_00_10_23.Still001.f5355639.jpg";